<template>
  <div>
    <BaseFrame
      @save="save"
      saveText='保存'
      >
      <div slot="content">
        <lk-card>
          <lk-form
            :model='saveParams'
            :label-width='140'
            label-position="right"
            ref="goodsForm"
            >
            <lk-row>
              <lk-col span='10'>
                <lk-form-item label='货位编码:' prop='locationCode'>
                  <lk-input v-model="saveParams.locationCode" size="large" clearable placeholder="货位编码"
                            style="width: 300px"/>
                </lk-form-item>f
              </lk-col>
              <lk-col span='10'>
                <lk-form-item label='货位描述:' prop='locationDescription'>
                  <lk-input v-model="saveParams.locationDescription" size="large" clearable placeholder="仓库编码" style="width: 300px"/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <lk-col span='10'>
                <lk-form-item label='所属仓库:' prop='warehouseId'>
                  <lk-select v-model="saveParams.warehouseId" style="width:200px">
                    <lk-option v-for="item in warehouseData" :value="item.value" :key="item.value">{{ item.label
                      }}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span='10'>
                <lk-form-item label='是否有无商品:' prop='warehouseRemark'>
                  <lk-input v-model="saveParams.warehouseRemark" size="large" clearable
                            placeholder="无" style="width: 300px"/>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';

export default {
  components: { BaseFrame },

  data() {
    return {
      saveParams: {
        warehouseId: null,
        locationCode: null,
        locationDescription: null,
        hasGoods: 2,
      },

      warehouseData: [],

    };
  },
  methods: {
    getWarehouseTable() {
      inventory.warehouseList(this.queryParams).then((res) => {
        if (res.status === 200) {
          res.data.data.list.forEach((val) => {
            const result = {
              value: val.id,
              label: val.warehouseName,
            };

            this.warehouseData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },


    save() {
      // this.managerList.forEach(val=>{
      //   if (val.value === this.saveParams.managerId) {
      //     this.saveParams.managerName = val.label;
      //   }
      // });

      // console.log(manager);

      inventory.saveLocationData(this.saveParams).then((res) => {
        if (res.status === 200 && res.data.status === 200) {
          this.$Message.success('保存成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

  },

  created() {
    this.getWarehouseTable();
  },


};
</script>
